module.exports = __webpack_public_path__ + "media/media/home/img9-d6bf27d1dc418396dc0f26dd37beae4f.png";